import { Link } from "react-router-dom";
import "../Css/Admin.css";
import "./css/Presentation.css"

export default function Presentation() {

  return (
    <div className="presentation-container">
    <Link className="link-img" to="/"><img className='admin-img' src="./Images/Icons/sunflower-icon-2.png"></img></Link>
    <div className="presentation">
        <div className="presentation-title">Salut à vous mes jeunes Azoves</div>
        <div className="presentation-text">
        Cette page vous présente une liste complète des résultats du sondage. Ici en bas vous avez des outils afin de trier
        et / ou filtrer les données. Si par hasard vous voulez revenir sur la page d'accueil, cliquez <Link className="text-link" to="/">ICI </Link> 
        ou sur la fleure.
        </div>
    </div>
    </div>
  );
}